import { ApisauceInstance } from 'apisauce'
import { CompanyTheme } from './types'
import { Mocks } from './mocks'

const LOCAL = false // Set to true for local development, false for production
const LOCAL_URL = 'http://localhost:8000/' 
const USE_MOCK_THEME = false // Set to true to use the mock theme, false to fetch from API
export class ThemeAPI {
  protected api: ApisauceInstance
  protected isDev: boolean

  constructor(api: ApisauceInstance, isDev: boolean = false) {
    this.api = api
    this.isDev = isDev
  }

  private getOptions(options?: object) {
    if (LOCAL) {
      return { ...(options || {}), baseURL: LOCAL_URL }
    }
    return options || {}
  }

  async retrieve(): Promise<CompanyTheme> { 
    if (USE_MOCK_THEME && this.isDev)
      return Promise.resolve(Mocks.theme)

    const response = await this.api.get<CompanyTheme>(
      'companies/theme/',
      {},
      this.getOptions()
    )
 
    return response.data
  }
}
